<template>
  <div class="container">
    <v-card>
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab>ΤΙΜΟΚΑΤΑΛΟΓΟΙ ΠΩΛΗΣΕΩΝ</v-tab>
        <v-tab>ΤΙΜΟΚΑΤΑΛΟΓΟΙ ΑΓΟΡΩΝ</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-data-table :headers="headers" :items="salesPricelists" :loading="loading" loading-text="Φόρτωση τιμοκαταλόγων πωλήσεων..." no-data-text="Δεν υπάρχουν δεδομένα" class="elevation-1">
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>Πωλήσεις</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn 
                      color="primary" 
                      rounded 
                      elevation="2" 
                      class="mb-2 px-4 font-weight-bold white--text" 
                      @click="createPricelist('sales')"
                    >
                      <v-icon left size="20">mdi-plus</v-icon>
                      <span>ΔΗΜΙΟΥΡΓΙΑ</span>
                    </v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small class="mr-2" @click="editPricelist(item, 'sales')">mdi-pencil</v-icon>
                    <v-icon small class="mr-2" @click="deletePricelist(item, 'sales')">mdi-delete</v-icon>
                    <v-btn small color="info" @click="manageEntries(item, 'sales')">ΔΙΑΧΕΙΡΙΣΗ ΕΙΔΩΝ</v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-data-table :headers="headers" :items="purchasePricelists" :loading="loading" loading-text="Φόρτωση τιμοκαταλόγων αγορών..." no-data-text="Δεν υπάρχουν δεδομένα" class="elevation-1">
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>Αγορές</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn 
                      color="primary" 
                      rounded 
                      elevation="2" 
                      class="mb-2 px-4 font-weight-bold white--text" 
                      @click="createPricelist('purchases')"
                    >
                      <v-icon left size="20">mdi-plus</v-icon>
                      <span>ΔΗΜΙΟΥΡΓΙΑ</span>
                    </v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small class="mr-2" @click="editPricelist(item, 'purchases')">mdi-pencil</v-icon>
                    <v-icon small class="mr-2" @click="deletePricelist(item, 'purchases')">mdi-delete</v-icon>
                    <v-btn small color="info" @click="manageEntries(item, 'purchases')">ΔΙΑΧΕΙΡΙΣΗ ΕΙΔΩΝ</v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Dialog for Create/Edit -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="editedItem.name" label="Όνομα Τιμοκαταλόγου"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
          <v-btn color="blue darken-1" text @click="save">ΑΠΟΘΗΚΕΥΣΗ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for Delete Confirmation -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Είστε σίγουροι για τη διαγραφή;</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">ΝΑΙ</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: true,
    tab: 0,
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'Όνομα', value: 'name' },
      { text: 'Ενέργειες', value: 'actions', sortable: false },
    ],
    salesPricelists: [],
    purchasePricelists: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      name: '',
      type: '', // 'sales' or 'purchases'
    },
    defaultItem: {
      id: 0,
      name: '',
      type: '',
    },
    actionType: '', // 'sales' or 'purchases' context for the dialog
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Νέος Τιμοκατάλογος' : 'Επεξεργασία Τιμοκαταλόγου';
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
        this.loading = true;
        axios.all([
            axios.get('/api/pricelists/sales'),
            axios.get('/api/pricelists/purchases')
        ]).then(axios.spread((sales, purchases) => {
            this.salesPricelists = sales.data;
            this.purchasePricelists = purchases.data;
        })).finally(() => { this.loading = false; });
    },

    createPricelist(type) {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.type = type;
        this.actionType = type;
        this.editedIndex = -1;
        this.dialog = true;
    },

    editPricelist(item, type) {
        this.editedIndex = this.salesPricelists.indexOf(item); // Note: index might be wrong if looking at purchases, but we use ID for API anyway
        this.editedItem = Object.assign({}, item);
        this.editedItem.type = type;
        this.actionType = type;
        this.dialog = true;
    },

    deletePricelist(item, type) {
        this.editedItem = Object.assign({}, item);
        this.editedItem.type = type;
        this.actionType = type;
        this.dialogDelete = true;
    },

    deleteItemConfirm() {
        const url = `/api/pricelists/${this.actionType}/${this.editedItem.id}`;
        axios.delete(url).then(() => {
            this.initialize();
            this.closeDelete();
        });
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    },

    closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    },

    save() {
        const url = this.editedIndex === -1 
            ? `/api/pricelists/${this.actionType}`
            : `/api/pricelists/${this.actionType}/${this.editedItem.id}`;
        
        const method = this.editedIndex === -1 ? 'post' : 'patch';

        axios[method](url, this.editedItem).then(() => {
            this.initialize();
            this.close();
        });
    },

    manageEntries(item, type) {
        // Navigate to details page
        this.$router.push({ 
            name: 'pricelist-editor', 
            params: { 
                id: item.id,
                type: type 
            }
        });
    }
  },
};
</script>
